import type { EvaluationPeriodOption } from '@/pages/ManagerAssessment/Evaluation/types';

import { CUSTOM_PERIOD_VALUE } from '@/pages/ManagerAssessment/Evaluation/components/EvaluationDatePeriod';

export interface CycleEvaluationPeriodSelection {
    selectedPeriod: string;
    periodStart?: Date;
    periodEnd?: Date;
    periods: EvaluationPeriodOption[];
}

export interface CycleEvaluationPeriodPayload {
    evaluationPeriodId: string | null;
    evaluationPeriodStart: string | null;
    evaluationPeriodEnd: string | null;
}

export interface PersistedCycleEvaluationPeriod {
    evaluationPeriodId?: string | null;
    evaluationPeriodStart?: string | null;
    evaluationPeriodEnd?: string | null;
}

const NO_PERIOD_VALUE = '';

export const resolvePersistedPeriodValue = ({
    evaluationPeriodId,
    evaluationPeriodStart,
    evaluationPeriodEnd,
}: PersistedCycleEvaluationPeriod): string => {
    if (evaluationPeriodId) {
        return evaluationPeriodId;
    }

    const hasOwnRange = Boolean(evaluationPeriodStart || evaluationPeriodEnd);

    return hasOwnRange ? CUSTOM_PERIOD_VALUE : NO_PERIOD_VALUE;
};

export const buildCycleEvaluationPeriodPayload = ({
    selectedPeriod,
    periodStart,
    periodEnd,
    periods,
}: CycleEvaluationPeriodSelection): CycleEvaluationPeriodPayload => {
    if (selectedPeriod === CUSTOM_PERIOD_VALUE) {
        return {
            evaluationPeriodId: CUSTOM_PERIOD_VALUE,
            evaluationPeriodStart: periodStart?.toISOString() ?? null,
            evaluationPeriodEnd: periodEnd?.toISOString() ?? null,
        };
    }

    const preset = periods.find((period) => period.value === selectedPeriod);

    if (!preset) {
        return {
            evaluationPeriodId: null,
            evaluationPeriodStart: null,
            evaluationPeriodEnd: null,
        };
    }

    return {
        evaluationPeriodId: preset.value,
        evaluationPeriodStart: new Date(preset.from).toISOString(),
        evaluationPeriodEnd: new Date(preset.to).toISOString(),
    };
};
